module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pFrontCover"
    }
  }), _c('a', {
    attrs: {
      "id": "pFrontFlap"
    }
  }), _c('a', {
    attrs: {
      "id": "pi"
    }
  }), _c('a', {
    attrs: {
      "id": "pii"
    }
  }), _c('a', {
    attrs: {
      "id": "piii"
    }
  }), _c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 2021 L. Jon Wertheim")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "http://hmhbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Names: Wertheim, L. Jon, author.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Title: Glory days : the summer of 1984 and the 90 days that changed sports and culture forever / L. Jon Wertheim.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Description: Boston : Houghton Mifflin Harcourt, 2021. | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Identifiers: LCCN 2020033845 (print) | LCCN 2020033846 (ebook) | ISBN 9781328637246 (hardcover) | ISBN 9780358449058 | ISBN 9780358449393 | ISBN 9781328637901 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Subjects: LCSH: Sports—History—20th Century. | Nineteen eighty-four, A.D.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Classification: LCC GV576 .W45 2021 (print) | LCC GV576 (ebook) | DDC 796.09048—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2020033845",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2020033845")])]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("LC ebook record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2020033846",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2020033846")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Cover design by Brian Moore")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Cover photographs: © Bob Thomas Sports Photography / Getty Images\n(Retton); © Andrew D. Bernstein / NBAE / Getty Images (Johnson / Bird);\n© Heinz Kluetmeier / Sports Illustrated / Getty Images (Jordan); © Bruce\nBennett Studios / Getty Images (Gretzky); © Richard E. Aaron / Redferns /\nGetty Images (Prince); © Richard McCaffrey / Michael Ochs Archive / Getty\nImages (Springsteen)")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Author photograph © John Filo")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("v2.0721")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Part of the introduction was first published, in different form, as the 2014 article “Rare Air Time: Michael Jordan, the ’84 U.S. Olympic Trials and Me,” by Jon Wertheim for "), _c('em', [_vm._v("Sports Illustrated")]), _vm._v(" online.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0